import JSONModel from "sap/ui/model/json/JSONModel";
import BaseController from "../../controller/BaseController";
import { Button$PressEvent } from "sap/m/Button";
import DataService from "../../util/DataService";
import Validator from "../../util/Validator";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class PendingRequestsController extends BaseController {

    private readonly APPROVE_DIALOG_ID = "DialogLeaveRequestApprove";
    private readonly REJECT_DIALOG_ID = "DialogLeaveRequestReject";

    public async onInit(): Promise<void> {

    }

    async onApproveLeave(oEvent: Button$PressEvent): Promise<void> {
        const leave = oEvent.getSource().getBindingContext("dataModel").getObject();
        this.getView().setModel(new JSONModel({
            ...leave,
            status: "APPROVED"
        }), "leave");
        await this.openDialog(this.APPROVE_DIALOG_ID);
    }

    async onRejectLeave(oEvent: Button$PressEvent): Promise<void> {
        const leave = oEvent.getSource().getBindingContext("dataModel").getObject();
        this.getView().setModel(new JSONModel({
            ...leave,
            status: "REJECTED"
        }), "leave");
        await this.openDialog(this.REJECT_DIALOG_ID);

    }

    async onSaveDialog(oEvent: Button$PressEvent): Promise<void> {

        const validator = new Validator();
        const valid = validator.validate(oEvent.getSource().getParent());
        if (!valid) return;

        const leave = this.getView().getModel("leave") as JSONModel;
        const dialogId = oEvent.getSource().getParent().getParent().getId();
        DataService.processLeaveRequest(leave.getData());
        this.destroyDialog(dialogId);
    }

    onCloseDialog(oEvent: Button$PressEvent): void {
        const dialogId = oEvent.getSource().getParent().getParent().getId();
        this.destroyDialog(dialogId);
    }

}
